<p-table
  [value]="members"
  class="tw-rounded-lg tw-shadow tw-bg-white tw-w-full"
  [paginator]="false"
  [rows]="10"
  selectionMode="single"
  [style]="{ width: '100%' }"
  [scrollable]="true"
  scrollHeight="400px"
>
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="firstName" scope="col">
        First Name
        <p-sortIcon field="firstName"></p-sortIcon>
      </th>
      <th pSortableColumn="lastName" scope="col">
        Last Name
        <p-sortIcon field="lastName"></p-sortIcon>
      </th>
      <th pSortableColumn="tenantId" scope="col">
        Tenant
        <p-sortIcon field="tenantId"></p-sortIcon>
      </th>
      <th pSortableColumn="date" scope="col" [pSortableColumnDisabled]="false">
        Date
        <p-sortIcon field="date"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-member>
    <tr
      class="tw-cursor-pointer hover:tw-bg-blue-100"
      (click)="onRowClick(member, $event)"
      pTooltip="{{ member.url }}"
      tooltipPosition="top"
    >
      <td>{{ member.firstName }}</td>
      <td>{{ member.lastName }}</td>
      <td>{{ member.tenantId }}</td>
      <td>{{ member.date | date: 'short' }}</td>
    </tr>
  </ng-template>
</p-table>
